import styles from './ratingsPerLevel.scss';
import cn from 'classnames';
import { RatingPerLevel } from 'models/RatingPerLevel';
import { rm } from 'utils';

const getPercentageForLevel = (total: number, levelValue: number) => (levelValue / total) * 100;

interface OwnProps {
  levels: RatingPerLevel[];
  isMobileLayout: boolean;
}
export const RatingsPerLevel = ({ levels, isMobileLayout }: OwnProps) => {
  const total = levels.reduce((total, { value }) => total + value, 0);

  const sortedLevels = levels.slice().sort((a, b) => b.level - a.level);

  const leftNumbers = sortedLevels.map(({ level }, i) => (
    <div key={i} className={styles.leftNumber}>
      {level}
      <div className={styles.starsText}> {rm('product_review_ratings_stars')}</div>
    </div>
  ));

  const rightNumbers = sortedLevels.map(({ value }, i) => (
    <div key={i} className={styles.rightNumber}>
      {value}
    </div>
  ));

  const bars = sortedLevels.map((level, index) => {
    const isFirstBar = index === 0;
    const isLastBar = index === sortedLevels.length - 1;

    return (
      <div
        key={index}
        className={cn(styles.outerBar, {
          [styles.firstBar]: isFirstBar,
          [styles.lastBar]: isLastBar
        })}
      >
        <div
          className={styles.filling}
          style={{ width: `${getPercentageForLevel(total, level.value)}%` }}
        />
      </div>
    );
  });

  return (
    <div>
      {isMobileLayout && (
        <div className={styles.introTextMobile}>{rm('product_review_information_disclaimer')}</div>
      )}

      <div className={styles.ratingsPerLevelContainer}>
        <div className={styles.leftNumbersContainer}>{leftNumbers}</div>
        <div className={styles.barsContainer}>{bars}</div>
        <div className={styles.rightNumbersContainer}>{rightNumbers}</div>
        {!isMobileLayout && (
          <div className={styles.introText}>{rm('product_review_information_disclaimer')}</div>
        )}
      </div>
    </div>
  );
};
